exports = module.exports = require("./../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "table.calendar td.row_header{font-weight:700}body{font-family:sans-serif}body,table.calendar{background-color:#fff}table.calendar{border-collapse:collapse;border:1px solid grey}table.calendar thead{background-color:#fff;margin-bottom:3px}table.calendar thead th{font-weight:700;border:1px solid grey;padding:10px}table.calendar td{text-align:center;padding:12px;cursor:pointer;border:1px solid grey}table.calendar td.otherMonth{color:#d3d3d3;cursor:default;pointer-events:none}table.calendar td.selected{font-weight:700;color:red}", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader!./~/sass-loader!./app/main.scss
 ** module id = 95
 ** module chunks = 0
 **/